import { render, staticRenderFns } from "./downloadnew.vue?vue&type=template&id=bbab0f86&scoped=true&"
import script from "./downloadnew.vue?vue&type=script&lang=js&"
export * from "./downloadnew.vue?vue&type=script&lang=js&"
import style0 from "./downloadnew.vue?vue&type=style&index=0&id=bbab0f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbab0f86",
  null
  
)

export default component.exports